import { YuLifeLocale } from "hooks";

type Data = Record<
  YuLifeLocale,
  {
    cookiesLegalPage: {
      link: string;
    };
    cookiesModal: {
      heading: string;
      necessaryHeader: string;
      necessaryDesc: string;
      analyticsHeader: string;
      analyticsDesc: string;
      advertisingHeader: string;
      advertisingDesc: string;
      personalisationHeader: string;
      personalisationDesc: string;
      personalisationMessage: string;
      securityHeader: string;
      securityDesc: string;
      securityMessage: string;
      acceptAll: string;
      reject: string;
      saveSettings: string;
    };
    cookiesTable: {
      cookie: string;
      provider: string;
    };
    cookiesPopup: {
      message: string;
      accept: string;
      manage: string;
    };
  }
>;

const data: Data = {
  uk: {
    cookiesLegalPage: {
      link: "Manage cookie preferences ",
    },
    cookiesModal: {
      heading: "Manage your preferences",
      necessaryHeader: "Necessary cookies",
      necessaryDesc:
        "These cookies are necessary for the functionality of the website. If you choose to manually disable all cookies in your browser, this may affect how the website functions.",
      analyticsHeader: "Analytics cookies",
      analyticsDesc:
        "These are third-party cookies, used to help us understand how visitors use the website. With these insights, we can improve the website’s functionality.",
      advertisingHeader: "Advertising cookies",
      advertisingDesc:
        "These are third-party cookies that allow us to provide advertising to website visitors.",
      personalisationHeader: "Personalisation cookies",
      personalisationDesc:
        "These are cookies that enable storage related to personalization, such as video recommendations.",
      personalisationMessage:
        "We don’t currently have any cookies of this kind, but we will save your preferences.",
      securityHeader: "Security cookies",
      securityDesc:
        "These are cookies that enable storage related to security, such as authentication functionality and fraud prevention.",
      securityMessage:
        "We don’t currently have any cookies of this kind, but we will save your preferences.",
      acceptAll: "Accept all",
      reject: "Reject",
      saveSettings: "Save settings",
    },
    cookiesTable: {
      cookie: "Cookie",
      provider: "Provider",
    },
    cookiesPopup: {
      message:
        "We use cookies to ensure that we give you the best experience on our website, including cookies from third parties.",
      accept: "Accept all",
      manage: "Manage your preferences",
    },
  },
  us: {
    cookiesLegalPage: {
      link: "Manage cookie preferences ",
    },
    cookiesModal: {
      heading: "Manage your preferences",
      necessaryHeader: "Necessary cookies",
      necessaryDesc:
        "These cookies are necessary for the functionality of the website. If you choose to manually disable all cookies in your browser, this may affect how the website functions.",
      analyticsHeader: "Analytics cookies",
      analyticsDesc:
        "These are third-party cookies, used to help us understand how visitors use the website. With these insights, we can improve the website’s functionality.",
      advertisingHeader: "Advertising cookies",
      advertisingDesc:
        "These are third-party cookies that allow us to provide advertising to website visitors.",
      personalisationHeader: "Personalisation cookies",
      personalisationDesc:
        "These are cookies that enable storage related to personalization, such as video recommendations.",
      personalisationMessage:
        "We don’t currently have any cookies of this kind, but we will save your preferences.",
      securityHeader: "Security cookies",
      securityDesc:
        "These are cookies that enable storage related to security, such as authentication functionality and fraud prevention.",
      securityMessage:
        "We don’t currently have any cookies of this kind, but we will save your preferences.",
      acceptAll: "Accept all",
      reject: "Reject",
      saveSettings: "Save settings",
    },
    cookiesTable: {
      cookie: "Cookie",
      provider: "Provider",
    },
    cookiesPopup: {
      message:
        "We use cookies to ensure that we give you the best experience on our website, including cookies from third parties.",
      accept: "Accept all",
      manage: "Manage your preferences",
    },
  },
  za: {
    cookiesLegalPage: {
      link: "Manage cookie preferences ",
    },
    cookiesModal: {
      heading: "Manage your preferences",
      necessaryHeader: "Necessary cookies",
      necessaryDesc:
        "These cookies are necessary for the functionality of the website. If you choose to manually disable all cookies in your browser, this may affect how the website functions.",
      analyticsHeader: "Analytics cookies",
      analyticsDesc:
        "These are third-party cookies, used to help us understand how visitors use the website. With these insights, we can improve the website’s functionality.",
      advertisingHeader: "Advertising cookies",
      advertisingDesc:
        "These are third-party cookies that allow us to provide advertising to website visitors.",
      personalisationHeader: "Personalisation cookies",
      personalisationDesc:
        "These are cookies that enable storage related to personalization, such as video recommendations.",
      personalisationMessage:
        "We don’t currently have any cookies of this kind, but we will save your preferences.",
      securityHeader: "Security cookies",
      securityDesc:
        "These are cookies that enable storage related to security, such as authentication functionality and fraud prevention.",
      securityMessage:
        "We don’t currently have any cookies of this kind, but we will save your preferences.",
      acceptAll: "Accept all",
      reject: "Reject",
      saveSettings: "Save settings",
    },
    cookiesTable: {
      cookie: "Cookie",
      provider: "Provider",
    },
    cookiesPopup: {
      message:
        "We use cookies to ensure that we give you the best experience on our website, including cookies from third parties.",
      accept: "Accept all",
      manage: "Manage your preferences",
    },
  },
  jp: {
    cookiesLegalPage: {
      link: "クッキー設定を変更する ",
    },
    cookiesModal: {
      heading: "設定を変更する",
      necessaryHeader: "必須クッキー",
      necessaryDesc:
        "これらのクッキーは、ウェブサイトの機能に必要不可欠です。ブラウザの設定で全ての\\nクッキーを手動で無効にすると、ウェブサイトの機能に影響が出る可能性があります。",
      analyticsHeader: "分析クッキー",
      analyticsDesc:
        "本サードパーティークッキーは、ウェブサイトのユーザーエクスペリエンス向上を目的と\\nしたデータ収集・分析に用いられます。",
      advertisingHeader: "広告クッキー",
      advertisingDesc:
        "これらのサードパーティークッキーは、ウェブサイトの訪問者に広告を提供するために使\\n用されます。",
      personalisationHeader: "パーソナライゼーション・クッキー",
      personalisationDesc:
        "ユーザーの行動や嗜好に基づいて、ウェブサイトのコンテンツや広告をパーソナライズす\\nるために使用されるクッキーです。",
      personalisationMessage: "現在は本クッキーは使用しておりませんが、閲覧情報は保存されます。",
      securityHeader: "セキュリティー・クッキー",
      securityDesc:
        "ユーザーの認証や不正アクセス防止などのセキュリティ関連情報を保存するために使用さ\\nれるクッキーです。",
      securityMessage: "現在は本クッキーは使用しておりませんが、閲覧情報は保存されます。",
      acceptAll: "同意する",
      reject: "拒否する",
      saveSettings: "設定を保存",
    },
    cookiesTable: {
      cookie: "クッキーの名称",
      provider: "送信先",
    },
    cookiesPopup: {
      message:
        "当ウェブサイトでは、お客様により良い体験を\\n提供するために、クッキーを使用しています\\n（サードパーティークッキーを含む）。",
      accept: "同意する",
      manage: "設定を管理する",
    },
  },
};

export default data;
